import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { loginBO, OnboardingCredential } from './onboarding.model';
import { ErrorService } from 'src/app/error.service';

@Injectable({
    providedIn: 'root'
})
export class onboardingservice {
    constructor(private http: HttpClient, public errorService: ErrorService) { }
    registerJobPortal(saveJob: OnboardingCredential): Observable<any> {
        let url = "api/OnboardLogin/SaveOnboardAccount";
        return this.http.post<any>(url, saveJob, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }
    loginportal(saveJob: loginBO): Observable<any> {
        let url = "api/Auth/login";
        return this.http.post<any>(url, saveJob, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    // .........................................forgotpasswordclient..................................................//
    forgotPasswordclient(paramsData: URLSearchParams): Observable<any> {
        let url = "api/Auth/forgotPassword?";
        return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    OnboardLoginAuthentication(LoginPayLoad: loginBO): Observable<any> {
        let url = "api/Auth/login";
        return this.http.post<any>(url, LoginPayLoad, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    // For Client Onboarding Side Menus
    getsideMenuforClientOnboarding(): Observable<any> {
        let Clientsidemenudatas = [
          
           
            {
                "id": 1,
                "title": "Dynamic Client Form",
                "routerLink": "/client-employee-form",   //this is for routing
                "link": "/client-employee-form",         //this is authguard
                "href": null,
                "icon": "book",
                "target": null,
                "hasSubMenu": false,
                "parentId": 0,
            },
            // {
            //     "id": 2,
            //     "title": "Consultation Sessions",
            //     "routerLink": "/consultationsession",
            //     "link": "/consultationsession",
            //     "href": null,
            //     "icon": "file",
            //     "target": null,
            //     "hasSubMenu": false,
            //     "parentId": 0,
            // },
            
            {
                "id": 3,
                "title": "Service Delivery Plan",
                "routerLink": "/serviceplan",
                "link": "/serviceplan",
                "href": null,
                "icon": "money",
                "target": null,
                "hasSubMenu": false,
                "parentId": 0,
            },
            {
                "id": 4,
                "title": "Handbook",
                "routerLink": "/handbook",
                "link": "/handbook",
                "href": null,
                "icon": "book",
                "target": null,
                "children": null,
                "parentId": 0,
            },
            // {
            //     "id": 5,
            //     "title": "Import Payment",
            //     "routerLink": "/importpayment",
               
               
            //     "href": null,
            //     "icon": "file",
            //     "target": null,
            //     "hasSubMenu": false,
            //     "parentId": 0,
            // }
            

        ];
        return of(Clientsidemenudatas);
    }

    // For Employee Onboarding Side Menus
    getsideMenuforEmployeeOnboarding(): Observable<any> {

        let Employeesidemenudatas = [
            {
                "id": 2,
                "title": "Dynamic Employee Forms",
                "routerLink": "/client-employee-form",
                "link":"/client-employee-form",
                "href": null,
                "icon": "users",
                "target": null,
                "children": null,
                "parentId": 0,
            },
            {
                "id": 3,
                "title": "Handbook",
                "routerLink": "/handbook",
                "link": "/handbook",
                "href": null,
                "icon": "book",
                "target": null,
                "children": null,
                "parentId": 0,
            },


        ]
        return of(Employeesidemenudatas);
    }





}